import React, { useEffect, useState } from "react";
import { closeModal, LoadingDiv, SweetAlertShow } from "../master/Master";
import {
  expenseCategoryList,
  ExpenseCreate,
  ExpenseDelete,
  ExpenseUpdate,
} from "../../api/Expenses";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import Swal from "sweetalert2";
import Master from "./Master";
import usePrivateLink from "../config/usePrivateLink";
import ExpenseLayout from "./ExpenseLayout";

export default function ExpenseCategory() {
  const hasAccess = usePrivateLink();
  const [loading, setLoading] = useState(false);
  const [expenses, setExpenses] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [filters, setFilters] = useState({});

  const AddExpenses = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await ExpenseCreate(formData);
      if (response?.data?.status) {
        closeModal("AddCategory");
        getExpenseCategory();
        e.target.reset();
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };
  const UpdateExpenses = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await ExpenseUpdate(formData);

      if (response?.data?.status) {
        closeModal("Edit");
        getExpenseCategory();
        e.target.reset();
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };
  const handleDelete = async (id) => {
    setLoading(true);
    try {
      const response = await ExpenseDelete(id);

      if (response?.data?.status) {
        getExpenseCategory();
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getExpenseCategory = async () => {
    setLoading(true);
    let addUrl = "";
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value) {
        addUrl += `&${key}=${encodeURIComponent(value)}`;
      }
    });
    try {
      const response = await expenseCategoryList(addUrl);
      if (response.data.status) {
        setExpenses(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getExpenseCategory();
  }, [filters]);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <ExpenseLayout />
                  <div className="col-12">
                    <div className="card border-0 shadow-sm mb-3">
                      <div className="card-body">
                        <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3">
                          <div>
                            <h3 className="fw-bold mb-1">Expense Categories</h3>

                            <p className="text-muted mb-0">
                              Create and manage expense categories.
                            </p>
                          </div>

                          <div className="d-flex gap-2">
                            <span className="badge bg-label-primary fs-6 px-3 py-2">
                              {expenses?.length || 0} Categories
                            </span>

                            {hasAccess("/expense/category/add") && (
                              <button
                                className="btn btn-primary"
                                data-bs-toggle="modal"
                                data-bs-target="#AddCategory"
                              >
                                <i className="ri-add-line me-2"></i>
                                Add Category
                              </button>
                            )}
                          </div>
                        </div>

                        <hr className="my-4" />

                        <div className="row g-3 align-items-end">
                          <div className="col-lg-5">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="search"
                                className="form-control"
                                placeholder="Search Category"
                                value={filters?.search}
                                onChange={(e) =>
                                  setFilters((prev) => ({
                                    ...prev,
                                    search: e.target.value,
                                  }))
                                }
                              />

                              <label>Search Category</label>
                            </div>
                          </div>

                          <div className="col-lg-2">
                            <button
                              className="btn btn-outline-secondary w-100"
                              onClick={() => setFilters({})}
                            >
                              <i className="ri-refresh-line me-2"></i>
                              Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card border-0 shadow-sm">
                      <div className="card-body p-0">
                        <div className="d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
                          <div>
                            <h5 className="fw-bold mb-0">Category List</h5>

                            <small className="text-muted">
                              {expenses?.length || 0} Categories Available
                            </small>
                          </div>
                        </div>

                        <div className="table-responsive">
                          <table className="table table-hover align-middle mb-0">
                            <thead className="table-light">
                              <tr>
                                <th width="60">#</th>

                                <th>Category</th>

                                <th>Description</th>

                                <th width="140" className="text-center">
                                  Action
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {expenses?.length > 0 ? (
                                expenses.map((item, index) => (
                                  <tr key={item.id}>
                                    <td className="fw-semibold">{index + 1}</td>

                                    <td>
                                      <div className="fw-bold text-primary">
                                        {item.title}
                                      </div>

                                      {item.id <= 23 && (
                                        <small className="badge rounded-pill bg-label-info mt-1">
                                          System Category
                                        </small>
                                      )}
                                    </td>

                                    <td>
                                      <div className="text-muted">
                                        {item.description || "-"}
                                      </div>
                                    </td>

                                    <td>
                                      {item.id > 23 && (
                                        <div className="d-flex justify-content-center gap-2">
                                          {hasAccess(
                                            "/expense/category/edit",
                                          ) && (
                                            <button
                                              className="btn btn-sm btn-outline-primary"
                                              data-bs-toggle="modal"
                                              data-bs-target="#Edit"
                                              onClick={() => setModalData(item)}
                                            >
                                              <i className="ri-pencil-line"></i>
                                            </button>
                                          )}

                                          {hasAccess(
                                            "/expense/category/delete",
                                          ) && (
                                            <button
                                              className="btn btn-sm btn-outline-danger"
                                              onClick={() => {
                                                Swal.fire({
                                                  title: "Delete Category?",
                                                  text: "This action cannot be undone.",
                                                  icon: "warning",
                                                  showCancelButton: true,
                                                  confirmButtonColor: "#d33",
                                                  cancelButtonColor: "#6c757d",
                                                  confirmButtonText: "Delete",
                                                }).then((result) => {
                                                  if (result.isConfirmed) {
                                                    handleDelete(item.id);
                                                  }
                                                });
                                              }}
                                            >
                                              <i className="ri-delete-bin-line"></i>
                                            </button>
                                          )}
                                        </div>
                                      )}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="4" className="text-center py-5">
                                    <i
                                      className="ri-folder-open-line text-secondary"
                                      style={{ fontSize: 50 }}
                                    />

                                    <h5 className="mt-3">
                                      No Categories Found
                                    </h5>

                                    <p className="text-muted mb-0">
                                      No expense categories available.
                                    </p>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="AddCategory" tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form className="" onSubmit={AddExpenses}>
              <div className="modal-header border-0 pb-0">
                <h1 className="modal-title fs-5">Add New Expense</h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                />
              </div>
              <div className="modal-body">
                <div className="mb-3 form-floating-outline form-floating">
                  <input
                    type="text"
                    name="title"
                    className="form-control input-capitalize"
                  />
                  <label>Title</label>
                </div>

                <div className="mb-3 form-floating form-floating-outline">
                  <input
                    type="text"
                    name="description"
                    className="form-control input-uppercase"
                  />
                  <label>Description</label>
                </div>
              </div>
              <div className="modal-footer border-0 pt-0">
                <button
                  type="submit"
                  className="btn btn-primary px-4"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Saving...
                    </>
                  ) : (
                    <>
                      <i className="ri-check-line me-2"></i>
                      Save Category
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal fade" id="Edit" tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form className="" onSubmit={UpdateExpenses}>
              <div className="modal-header border-0 pb-0">
                <h1 className="modal-title fs-5">Add New Expense</h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                />
              </div>
              <div className="modal-body">
                <input
                  type="hidden"
                  name="id"
                  className="form-control"
                  defaultValue={modalData?.id}
                />
                <div className="mb-3 form-floating-outline form-floating">
                  <input
                    type="text"
                    name="title"
                    className="form-control input-capitalize"
                    defaultValue={modalData?.title}
                  />
                  <label>Title</label>
                </div>

                <div className="mb-3 form-floating form-floating-outline">
                  <input
                    type="text"
                    name="description"
                    className="form-control input-uppercase"
                    defaultValue={modalData?.description}
                  />
                  <label>Description</label>
                </div>
              </div>
              <div className="modal-footer border-0 pt-0">
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Update"
                  )}
                  {loading ? " Updating..." : ""}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
